import { POPULATION_TYPE } from "@/common/models";
import { ModalType } from "./model";
import { ICONS } from "@/common/icons.map";

const to_tab = (
  type: ModalType
): { id: ModalType; name: string; icon: string } => {
  switch (type) {
    case POPULATION_TYPE.FOLDER:
      return {
        id: POPULATION_TYPE.FOLDER,
        name: "Folders",
        icon: ICONS.ENTITIES.get(POPULATION_TYPE.FOLDER),
      };
    case POPULATION_TYPE.FILE:
      return {
        id: POPULATION_TYPE.FILE,
        name: "Files",
        icon: ICONS.ENTITIES.get(POPULATION_TYPE.FILE),
      };
    case "CONTAINER":
      return {
        id: "CONTAINER",
        name: "Containers",
        icon: "Server",
      };
    case "DATA_BASE":
      return {
        id: "DATA_BASE",
        name: "Data bases",
        icon: "DB",
      };
    case "SERVER":
      return {
        id: "SERVER",
        name: "Servers",
        icon: "Server",
      };
    case "STORAGE":
    default:
      return {
        id: "STORAGE",
        name: "Storage",
        icon: "Container",
      };
  }
};
export const get_tabs = (
  types: ModalType[]
): Array<{ id: ModalType; name: string; icon: string }> => {
  return types.map(to_tab);
};
